import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ClockIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 7.58255C12.9897 7.58255 7.30769 13.2645 7.30769 20.2749C7.30769 27.2838 12.9898 32.9672 20 32.9672C27.0103 32.9672 32.6923 27.2838 32.6923 20.2749C32.6923 13.2645 27.0103 7.58255 20 7.58255ZM5 20.2749C5 11.99 11.7152 5.27486 20 5.27486C28.2848 5.27486 35 11.99 35 20.2749C35 28.5581 28.2849 35.2749 20 35.2749C11.7151 35.2749 5 28.5581 5 20.2749Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4878 13.6082C20.1251 13.6082 20.6417 14.1248 20.6417 14.762V20.4122L24.964 22.9953C25.5111 23.3222 25.6895 24.0307 25.3626 24.5778C25.0357 25.1247 24.3272 25.3032 23.7801 24.9762L18.8958 22.0573C18.5474 21.849 18.334 21.473 18.334 21.0668V14.762C18.334 14.1248 18.8506 13.6082 19.4878 13.6082Z"
        fill={props.fill || "currentColor" || "#3064C0"}
      />
    </svg>
  );
};

export default ClockIcon;
